import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactPage from "../pages/contact/page";
import AboutPage from "../pages/about/page";
import ComparisonPage from "../pages/comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/iletisim",
    element: <ContactPage />,
  },
  {
    path: "/hakkimizda",
    element: <AboutPage />,
  },
  {
    path: "/karsilastirma",
    element: <ComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
